<template>
<div class="home" style="min-height: 98vh;" :style="{'min-width': screen_min_width + 'px'}">
    
    <div style="width:100%;">
		<div class='nav-box'>
            <div class="nav-content-box" >
                <div style="display: flex;align-items: center;height: 100%;">
                  <!-- <div style="display: flex;align-items: center;margin-right:30px;min-width: 120px;font-size: 14px;cursor: default;">
                      <img style="width:30px;height:30px;" src="../assets/logo.png" alt="">
                      <p style="margin: 0;">飞碟管理系统</p>
                  </div> -->
				  <!-- logo -->
				  <img style="width: 120px;margin-right: 35px;" src="https://oss.gzlize.com/vue/admin-logo10.png" alt="">
				
                  <!-- 选择菜单 -->
					<div class="nav-select-box" :style="{'width': nav_select_width + 'px'}">
						<div class="one-title" v-for="(item,index) in navData" :key="index">
                          <p class="one-title-p"  @click="selectNav(item,index)" @mouseenter="navEnter(item,index)" :style="{color:(index===nav_index && nav_show_control)?'#409eff':''}">{{item.title}}</p>
                          <span v-show="item.select_status" class="nav-bottom-span" ></span>
						</div>
					</div>

                </div>
			    <a-popover placement="bottom" :getPopupContainer="getsPopupContainer">
			        <template slot="content">
			            <div @click="goSetInfor()" class='cz-button-calss'>设置</div>
			            <div @click="logOut()" class='cz-button-calss'>退出登录</div>
			        </template>
			        <div style="display: flex;align-items: center;cursor: pointer;">
			              <p class="nav-name">{{user_identity}}</p>
			              <i style="font-size:26px;" class="nav-icon el-icon-switch-button"></i>
			        </div>
			    </a-popover>
				
			  
            </div>
          
          <!-- 二级三级菜单的显示 -->
			<div v-show="nav_show_control"  @mouseleave="navLeave()" class="second-nav-box" :style="{'min-width': screen_min_width + 'px'}">
				<div v-for="(item,index) in secondNavData" :key="index" style="margin-right: 70px;">
                  <div class="second-title" @click="selectSecondNav(item,index)"  :style="{cursor:item.child.length > 0?'default':'pointer'}">{{item.title_2}}</div>

                  <div style="width:100%;height:1px;background-color:#ccc;margin: 15px 0;"></div>

                  <!-- 三级菜单 -->
				  <div v-if="item.child.length === 0" class="third-nav-unselect" style="cursor: default;">暂无内容</div>
                  <div v-else v-for="(item,index) in item.child" :key="index" style="display: flex;align-items: center;margin-bottom: 15px;">
					<div class="third-nav-select" @click="selectThirdNav(item,index)" style="margin-bottom: 0;">{{item.title_3}}</div>
					
					<!-- <a-tooltip placement="right" style="margin-left: 5px;">
				        <template slot="title">
				            <span>新窗口打开页面</span>
				        </template> -->
				        <!-- <a-icon type="arrow-up" @click="windowOpenPage(item)" style="margin-left: 5px;color: #999;cursor: pointer;transform:rotate(30deg)" /> -->
				    <!-- </a-tooltip> -->
					<img @click="windowOpenPage(item)" style="width: 15px;margin-left: 7px;margin-bottom: 2px;cursor: pointer;" src="../assets/window-open-icon.png" alt="图标">
				  </div>
				</div>
			
			</div>
		</div>
		<div style="height:65px;width:100%"></div>
        
    </div>
    
    <!-- 页面内容显示 -->
    <div style="padding: 20px 30px 30px;">
      <router-view/>
    </div>
    
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { getMenu, loginOut } from '@/request/api'

// 水印
import { removeWatermark, setWaterMark } from '@/plugins/watermark'

export default {
	name: 'home',
	components: {
	},
	data() {
		return {
		  navData:[
			{}
		  ],
		  secondNavData: [],
		  nav_show_control: false, // 二级三级导航条要不要显示,false为不显示
		  current_index: 0, // 当前选中的一级菜单索引。用于用户点击菜单展开下级菜单后，再点一次收起下级菜单
		  document_second_nav: "", // 保存元素节点
		  nav_select_width: 300, // 菜单栏盒子的宽度
		  screen_min_width: 1200, // 页面内容显示区域的最小宽度
		  
		  nav_index: 0, // 选择的导航条索引
		  
		  user_identity: "", // 用户身份
		  
		  search_button_loading: false, 
		  
		  jump_http: "",
		}
	},
    mounted(){
		let that = this
		
		this.jump_http = window.location.origin;
		
		that.search_button_loading = true
		
		// 顶部菜单栏的适配
		// console.log('屏幕宽',document.body.clientWidth)
		// console.log('屏幕高',document.body.clientHeight)
		this.nav_select_width = document.body.clientWidth - 55 - 126 - 35 - 80 - 50
		// console.log("this.$route.fullPath",this.$route.fullPath)
		let all_path = this.$route.fullPath.split('?')
		let route_path = all_path[0]
		// 获取菜单列表
		function getM(){
			getMenu().then(res=>{
				console.log('菜单',res.data)
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					let data = res.data.data.list || []
					console.log("login_home_path",localStorage.getItem('login_home_path'))
					// 默认调往，顶部菜单项的第一个页面
					if(localStorage.getItem('login_home_path') == 'login'){
						let uuu = ""
						console.log("data[0]",data[0])
						if(data[0].child.length == 0){
							uuu = data[0].vues[0].vue_url
						}
						else {
							console.log("data[0].child",data[0].child)
							if(data[0].child[0].child.length == 0){
								uuu = data[0].child[0].vues[0].vue_url
							}
							else {
								uuu = data[0].child[0].child[0].vues[0].vue_url
							}
						}
						console.log("uuu",uuu)
						// 重置状态
						localStorage.setItem("login_home_path",'home');
						// console.log("uuu",uuu)
						let jump_route = uuu.split('/vue3/')
						// console.log("jump_route",jump_route)
						// console.log("uuu",`${that.jump_http}/vue3/#/${jump_route[1]}`)
						if (uuu.indexOf("/vue3/") > -1) {
							let jump_route = uuu.split('/vue3/')
							window.location.replace(`${that.jump_http}/vue3/#/${jump_route[1]}`)
						}
						else {
							that.$router.replace({path: uuu})
						}
						
					}
					
					that.search_button_loading = false
					
					// data.forEach((res,index)=>{
					// 	res.select_status = false
					// 	if(index === 0){ //等菜单路径配置好了，就把这里注释
					// 		res.select_status = true
					// 	}
						
					// })
					// console.log("home页-data",data);
					// 根据当前所打开的路由地址，来判断那个导航条要高亮
					data.forEach((res,index)=>{
						if(route_path){
							// console.log("route_path",route_path)
							if(res.child.length > 0){
								res.child.forEach(res_c =>{
									if(res_c.child.length > 0){
										res_c.child.forEach((res_z,indzz)=>{
											res_z.vues.forEach(res_x=>{ // 导航菜单数据最多3层，这里已经是第三层了，没必要再判断res_z.child了。
												
												if(res_x.vue_url == route_path){
													console.log("res_x.vue_url",res_x.vue_url);
													console.log("route_path",route_path);
													res.select_status = true
												}
											})
										})
										
									}
									else {
										res_c.vues.forEach((zzz,indzz)=>{
											if(zzz.vue_url == route_path){
												res.select_status = true
											}
										})
									}
								})
							}
							else {
								res.vues.forEach((zzz,indzz)=>{
									if(zzz.vue_url == route_path){
										res.select_status = true
									}
								})
							}
						}
						else {
							if(index === 0){
								res.select_status = true
							}
							else {
								res.select_status = false
							}
						}
					})
					
					that.navData = res.data.data.list
					that.secondNavData = res.data.data.list[0].child
					
					localStorage.setItem("get_navData",JSON.stringify(res.data.data.list));
				}
				else if(res.data.code == 401){ // 未登录
					that.search_button_loading = false
					localStorage.removeItem("access_token");
					that.$router.replace({name: 'login',params: {type:'not_log'}})
					// that.$message.error(res.data.msg || '未登录错误');
				}
				else {
					that.search_button_loading = false
					that.$message.error(res.data.msg || '错误-获取菜单');
				}
				
			})
		}
		getM() // 执行
		
		// console.log('document',document.getElementsByClassName("second-nav-box"))
		// this.document_second_nav = document.getElementsByClassName("second-nav-box")
		
		// 菜单页面对于导航项的路径跳转进行修改后，这边要更新一下导航栏的数据
		this.$bus.$on('updateNav',(e)=>{
			console.log('home',e)
			getM()
		})
		
		// 获取用户身份
		that.user_identity = localStorage.getItem("user_name_identity") || '未知用户'
		
		// 放水印
		// let sy = localStorage.getItem("user_name_identity") || '未知用户'
		setWaterMark(that.user_identity, ''); // 第一个参数是水印名字，第二个参数也是水印名字。但是这里只需要一个水印名字。所以第二个参数填空
		
	},
	beforeDestroy(){
		this.$bus.$off('updateNav') // 销毁，减轻vue压力
		
		// 关闭水印
		removeWatermark()
	},
    methods: {
		// 给ant design的Tooltip 文字提示 重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 一级菜单 鼠标移入事件
		navEnter(e,index){
			// console.log("菜单栏 鼠标移入事件")
			this.nav_index = index
			this.secondNavData = this.navData[index].child || []
			
			if(e.child.length > 0){ // 有下级
				this.nav_show_control = true
			}
			else { // 没有下级菜单的
				this.nav_show_control = false
			}
		},
		// 选择菜单
		selectNav(e,index){
			// console.log(e)
			this.nav_index = index
			this.secondNavData = this.navData[index].child || []
			
			if(e.child.length > 0){ // 有下级
				// if(this.current_index === index){
				//   this.nav_show_control = !this.nav_show_control
				// }
				// else {
				//   this.current_index = index
				//   this.nav_show_control = true
				// }
			}
			else { // 没有下级菜单的
				// this.nav_show_control = false
				// 高亮横条
				this.navHighlight()
				if(e.vues[0].vue_url != this.$route.path){
					// console.log(this.$route.path)
					// this.$router.push({path: e.vues[0].vue_url})
					this.jumpRouter(e.vues[0].vue_url)
				}
				
			}
        
		},
		// 下级菜单栏 鼠标移出
		navLeave(){
			// console.log("下级菜单栏 鼠标移出")
			let that = this
			this.nav_show_control = false
		},
		// 选择二级菜单
		selectSecondNav(e,index){
			let that = this
			// console.log("e.vue_url",e.vue_url);
			// console.log("this.nav_index",this.nav_index);
			// this.$route.path获取当前路由地址
			if(e.child.length <= 0 && e.vues[0].vue_url){ // 没有下级，则二级菜单可以点击
				this.nav_show_control = false
				
				// 高亮横条
				this.navHighlight()
				
				if(e.vues[0].vue_url != this.$route.path){
					// this.$router.push({path: e.vues[0].vue_url})
					this.jumpRouter(e.vues[0].vue_url)
				}
			}
			
		},
		// 选择三级菜单
		selectThirdNav(e,index){
			// console.log(e);
			if(e.vues[0].vue_url){ // 有配置vue路径
				this.nav_show_control = false
				// this.$message.success(`选择菜单：${e.title}`);
				
				// 高亮横条
				this.navHighlight()
				// console.log(this.$route.path)
				if(e.vues[0].vue_url != this.$route.path){
					// this.$router.push({path: e.vues[0].vue_url})
					this.jumpRouter(e.vues[0].vue_url)
				}
			}
			
		},
		// 高亮导航条下面的横条
		navHighlight(){
			// console.log("this.navData",this.navData)
			// 控制选中的下方横条
			this.navData.forEach((res)=>{
				res.select_status = false
			})
			this.navData[this.nav_index].select_status = true
		},
		// 返回登录页
		logOut(){
			let vm = this
			this.$confirm({
				title: '确定要退出登录吗?',
				content: h => <div style="color:red;">点击 “确认退出” 按钮，退出登录</div>,
				okText:"确认退出",
				cancelText:"取消",
				onOk() {
					console.log('OK');
					loginOut().then(res=>{
						// console.log('登出',res)
						localStorage.removeItem("access_token");
						localStorage.removeItem("channel_content_type")
						// localStorage.clear();
						// if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
							vm.$router.replace({path: '/'})
						// }
						// else {
						// 	vm.$router.replace({path: '/'})
						// }
					})
				},
				onCancel() {
					console.log('Cancel');
				},
				class: 'test',
			});
		},
		// 隐藏盒子的事件应该绑定在最外层盒子（比如vue的app.vue的最外层div标签上），或者绑定在document
		navClose(event) { // 传入event对象
			console.log('event',event)
			// console.log('document',this.document_second_nav)
			// let documents = this.document_second_nav // 弹窗id
			// if (documents.includes(event.target)) { // 判断弹窗是否包含点击节点，不包含则在弹窗外，隐藏弹窗
			// 	this.nav_show_control = false
			// }
		},
		
		// 新窗口打开页面
		windowOpenPage(e){
			console.log(e);
			let rout_url = e.vues[0].vue_url
			if (rout_url.indexOf("/vue3/") > -1) { // 表示是vue3页面，要新开窗口打开
				let jump_route = rout_url.split('/vue3/') // 比如/vue3/designTeam，得把前面的/vue3去掉
				let href = `${this.jump_http}/vue3/#/${jump_route[1]}`
				window.open(href, '_blank');
			}
			else { // vue2页面
				const { href } = this.$router.resolve(e.vues[0].vue_url)
				window.open(href, '_blank');
			}
		},
		
		goSetInfor(){
			// console.log("路由地址",this.$route.fullPath);
			if(this.$route.fullPath != '/userInfor'){
				// this.$router.push({path: '/userInfor'})
				let href = `${this.jump_http}/vue3/#/userInfor`
				window.open(href, '_blank');
			}
		},
		
		jumpRouter(rout_url) {
			console.log("rout_url", rout_url)
			if (rout_url.indexOf("/vue3/") > -1) { // 表示是vue3页面，要新开窗口打开
				let jump_route = rout_url.split('/vue3/') // 比如/vue3/designTeam，得把前面的/vue3去掉
				let href = `${this.jump_http}/vue3/#/${jump_route[1]}`
				window.open(href, '_blank');
			}
			else { // vue2页面
				this.$router.push({ path: rout_url })
			}
			
		},
  }
}
</script>
<style scoped>
.nav-box {
  position: fixed;
  z-index: 999;
  /* 1051可以遮盖住antdesign的下拉选择器、侧边导航条 */
  /* z-index: 1051; */
  width: 100%;
  left: 0;
  top: 0;
  box-shadow: 0 2px 6px rgb(0 21 41 / 0.12);
  border-bottom: 1px solid #eee;
  background-color: #fff;
}
.nav-content-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 35px 0 20px;
    height: 65px;
}
.nav-select-box {
	display: flex;
	align-items: center;
	height: 100%;
	min-width: 500px;
}
.nav-name {
  font-weight: bold;
  margin: 0 10px 0 0;
  width: 90px;
  text-align: right;
}
/* 一级标题样式 */
.one-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    
    /* background-color: #999; */
    margin-right: 35px;
    height: 100%;
	/* padding: 0 10px; */
}
.one-title-p:hover p {
    color: #409eff;
}
.one-title-p {
    max-width:140px;
    /* min-width: 80px; */
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    margin: 0;
    font-size: 14px;
    user-select:none;
	cursor: pointer;
}
.nav-bottom-span {
    width:50px;
    height:3px;
    background-color:#409eff;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
}


/* 二级导航 */
.second-nav-box {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    background-color: #fff;
    width: 100%;
    /* height: 100px; */
    box-sizing: border-box;
    padding: 0 50px 30px 70px;
}
.second-title {
  padding-right: 15px;
  font-weight: 600;
  cursor: default;
  text-align: left;
  margin-top: 30px;
}

/* 三级导航 */
.third-nav-select,
.third-nav-unselect {
    font-size:14px;
    color:#706e6e;
    text-align: left;
    margin-bottom: 15px;
    cursor: pointer;
}
.third-nav-select:hover {
    color: #000;
}


.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}
</style>
